<template>
  <el-form label-width="80px" style="width: 95%;">
      <el-form-item label="节点名称">
        <el-input v-model="layerInfo_.name"></el-input>
      </el-form-item>
      <el-form-item label="图层地址">
        <el-input v-model="layerInfo_.url"></el-input>
      </el-form-item>
      <el-form-item label="图层名称">
        <el-input v-model="layerInfo_.layer"></el-input>
      </el-form-item>
      <el-form-item label="透明度">
        <el-slider v-model="layerInfo_.opacity" :max="1" :min="0" :step="0.1" ></el-slider>
      </el-form-item>
      <el-form-item label="定义查询" v-if="layerInfo_.serverType!=='WMTS'">
        <el-input v-model="layerInfo_.definition" type="textarea" :rows="5" :spellcheck ="false"></el-input>
      </el-form-item>
      <el-form-item label="统计图表:">
          <el-input v-model="layerInfo_.dataInfo"  placeholder="格式：统计名称1:大屏id1,统计名称2:大屏id2" />
      </el-form-item>
      <el-form-item label="图层顺序" >
        <el-input-number v-model="layerInfo_.zIndex" :min="1" :max="100" size="small" style="width:100%;"></el-input-number>
      </el-form-item>
      <el-form-item label="可见范围" >
        <el-slider v-model="layerRange_" range :min="min" :max="max" size="small"></el-slider>
      </el-form-item>
      <el-form-item label="服务类型:" v-if="showAll">
        <el-select v-model="layerInfo_.photoType" class="m-2" placeholder="请选择服务类型" size="small" style="width:100%">
          <el-option key="0" label="WMS" value="0" />
          <el-option key="1" label="WMTS" value="1" />
          <el-option key="2" label=" 3dtiles Service" value="2" />
        </el-select>
      </el-form-item>
      <el-form-item label="图片字段:" v-if="showAll">
          <el-input v-model="layerInfo_.imgPosition" placeholder="请用逗号分隔字段，例如：pz1,pz2"  />
      </el-form-item>
      <el-form-item label="图片地址:" v-if="showAll">
          <el-input v-model="layerInfo_.imgUrl"  />
      </el-form-item>
      <el-form-item label="字段翻译:" v-if="showAll">
         <el-input type="textarea" :rows="10" v-model="layerInfo_.translate" :spellcheck ="false"></el-input>
      </el-form-item>
      <el-form-item label="链接字段:" v-if="showAll">
          <el-input v-model="layerInfo_.linkFields" placeholder="请用逗号分隔字段，例如：pz1,pz2"  />
      </el-form-item>
      <el-form-item label="链接地址:" v-if="showAll" placeholder="字段值替换大括号，例如：{pz1}">
          <el-input v-model="layerInfo_.linkUrl"  />
      </el-form-item>
    </el-form>
</template>

<script>
export default {
  name: 'SdOlMapSdLayerConfig',
  props: {
    min:{
      type:Number,
      default:0
    },
    max:{
      type:Number,
      default:20
    },
    showAll:{
      type:Boolean,
      default:true
    }
  },
  data() {
    return {
      layerInfo_:{},
      layerRange_:[0,20],
      
    };
  },

  mounted() {
    
  },

  methods: {
    getData(){
      this.setLayerRange()
      return this.layerInfo_
    },
    reset(layerNode){
      this.layerInfo_ =layerNode? {
        name:layerNode.name,
        url:layerNode.url,
        layer:layerNode.layer,
        photoType:layerNode.photoType,
        imgPosition:layerNode.imgPosition,
        imgUrl:layerNode.imgUrl,
        translate:layerNode.translate,
        opacity:layerNode.opacity || 1,
        definition:layerNode.definition || '',
        zIndex:layerNode.zIndex || 0,
        serverType:layerNode.serverType || 'WMS',
        minZoom:layerNode.minZoom || 0,
        maxZoom:layerNode.maxZoom || 20,
        dataInfo:layerNode.dataInfo,
        linkFields:layerNode.linkFields,
        linkUrl:layerNode.linkUrl
      }:{}
      this.layerRange_ = this.getLayerRange(layerNode)
    },
    getLayerRange(lyr){
      return lyr?[lyr.minZoom || 0, lyr.maxZoom || 20]:[0,20]
    },
    setLayerRange(){
      this.layerInfo_.minZoom = this.layerRange_[0]
      this.layerInfo_.maxZoom = this.layerRange_[1]
    },
  },
};
</script>